import { lazy } from "react";

export const VisitFormAsync = lazy(() => import("./VisitForm"));
